var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseLabel',{attrs:{"text":_vm.statusLabel,"color":_vm.labelColor,"shade":_vm.BaseLabelShade.light}})}
var staticRenderFns = []

export { render, staticRenderFns }